
import { Hierarchy } from '../../../hierarchies/domain/types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getHierarchyRepository } from '~~/apps/hierarchies/inversify.config'

@Component
export default class LowResultsAllCountries extends Vue {
  @Prop()
    counts: Record<string, number>

  isMounted = false

  countryList: Hierarchy[] = []
  async setCountryList() {
    try {
      this.countryList = await getHierarchyRepository().getCountries(
        this.$route.params.lang || 'en-gb',
      )
    } catch (error) {
      this.$sentry.captureException(error)
    }
  }

  mounted() {
    this.setCountryList()
    this.isMounted = true
  }

  isNotLast(index: number) {
    return index !== this.countryList.length - 1
  }
}
